{
    "status": {
        "connecting": "Connecting",
        "open": "Open",
        "closed": "Closed"
    }
}
